import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import QuestionList from '../QuestionList/QuestionList';
import './MyReplies.css';
import { BASE_URL } from '../../utils/api';

const MyReplies = () => {
  const [myRepliedQuestions, setMyRepliedQuestions] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const fetchMyRepliedQuestions = async () => {
      const token = localStorage.getItem('accessToken');
      console.log('Token in MyReplies:', token);
      if (!token) {
        console.log('No token found, redirecting to login');
        navigate('/login');
        return;
      }

      try {
        console.log('Fetching my replied questions from API...');
        const response = await fetch(`${BASE_URL}/replies/my-replies/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        console.log('Response status:', response.status);
        if (!response.ok) {
          console.log('Response not OK:', response.status);
          if (response.status === 401) {
            localStorage.removeItem('accessToken');
            navigate('/login');
          } else if (response.status === 404) {
            setError('API endpoint not found. Please check the backend configuration.');
          } else if (response.status === 500) {
            setError('Server error occurred. Please try again later.');
          } else if (response.status === 403) {
            setError('You do not have permission to access this resource.');
          } else {
            setError(`Failed to fetch questions (Status: ${response.status}). Please try again.`);
          }
          return;
        }
        const data = await response.json();
        console.log('Fetched data:', data);
        
        // Group replies by question
        const questionsMap = new Map();
        
        data.forEach(reply => {
          const questionId = reply.question.id;
          if (!questionsMap.has(questionId)) {
            questionsMap.set(questionId, {
              id: reply.question.id,
              title: reply.question.title,
              details: reply.question.details,
              category: reply.question.category,
              created_at: reply.question.created_at,
              user: reply.user,
              replies: [],
              tags: [reply.question.category]
            });
          }
          questionsMap.get(questionId).replies.push(reply);
        });
        
        // Convert map to array
        const transformedQuestions = Array.from(questionsMap.values());
        
        setMyRepliedQuestions(transformedQuestions);
      } catch (err) {
        console.error('Fetch error:', err);
        setError('Network error occurred. Please check your connection or backend server.');
        navigate('/login');
      }
    };

    fetchMyRepliedQuestions();
  }, [navigate]);

  return (
    <div className="my-replies-container">
      <h2 className="my-replies-title">My Replies</h2>
      {error ? (
        <p className="error-message">{error}</p>
      ) : (
        <QuestionList questions={myRepliedQuestions} showAskButton={false} />
      )}
    </div>
  );
};

export default MyReplies;